<template>
  <DashboardChartWrapper
    title="Ventes par type"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <Doughnut v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { computed } from 'vue'
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardChartWrapper from './DashboardChartWrapper.vue'

ChartJS.register(ArcElement, Tooltip, Legend)

const labelMap = {
  single: 'Comptant',
  deferred: 'Credit'
}

const colorMap = {
  single: '#3b82f6',
  deferred: '#f59e0b'
}

const { dateParams } = useDateRange()
const { data, loading, error, refresh } = useDashboard('/dashboard/charts/sales-by-type', dateParams)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => labelMap[d.label] || d.label),
    datasets: [{
      data: data.value.map(d => d.total),
      backgroundColor: data.value.map(d => colorMap[d.label] || '#6b7280'),
      borderWidth: 2,
      borderColor: '#fff'
    }]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '60%',
  plugins: {
    legend: { position: 'bottom', labels: { usePointStyle: true, pointStyle: 'circle', padding: 16 } },
    tooltip: {
      callbacks: {
        label: (ctx) => `${ctx.label}: ${formatCurrency(ctx.raw)}`
      }
    }
  }
}
</script>
